import client from './axiosConfig';


export const getReturnNotes = (params) => {
    const config = {
        url: `/inventory/return-notes/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const getReturnNotesById = (id) => {
    const config = {
        url: `/inventory/return-notes/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
}


export const postReturnNote = (data) => {
    const config = {
        url: `/inventory/return-notes/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const patchReturnNote = (rn_id, data) => {
    const config = {
        url: `/inventory/return-notes/${rn_id}/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
};

export const deleteReturnNote = (rn_id) => {
    const config = {
        url: `/inventory/return-notes/${rn_id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
};
